var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepImage3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1510_21)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 43.5,
    r: 8.5,
    fill: "#182D45"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 43.5,
    r: 8,
    stroke: "url(#paint0_linear_1510_21)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6204 48.1488C46.1079 48.1488 45.6202 48.0537 45.1573 47.8636C44.6945 47.6652 44.3018 47.3883 43.9795 47.0329C43.6571 46.6775 43.4422 46.2601 43.3348 45.7807L45.0334 45.2103C45.1739 45.6071 45.3805 45.9088 45.6533 46.1154C45.9261 46.3138 46.2484 46.413 46.6204 46.413C46.9262 46.413 47.1866 46.3551 47.4015 46.2394C47.6247 46.1237 47.7982 45.9625 47.9222 45.7559C48.0462 45.541 48.1082 45.293 48.1082 45.012C48.1082 44.7309 48.0462 44.4912 47.9222 44.2928C47.8065 44.0862 47.637 43.9292 47.4139 43.8217C47.199 43.706 46.9345 43.6481 46.6204 43.6481C46.4385 43.6481 46.2567 43.6688 46.0748 43.7101C45.893 43.7514 45.7277 43.8093 45.5789 43.8837L45.1325 42.9538L47.5007 40.3749H43.8927V38.7631H49.658V40.2509L47.2279 43.0158L47.2899 42.2347C47.8437 42.2347 48.3231 42.3504 48.7281 42.5818C49.1414 42.805 49.4596 43.1191 49.6828 43.5241C49.9142 43.9292 50.03 44.4003 50.03 44.9376C50.03 45.5492 49.8812 46.0989 49.5836 46.5866C49.2861 47.0742 48.881 47.4586 48.3686 47.7396C47.8561 48.0124 47.2734 48.1488 46.6204 48.1488Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1510_21",
    x: 0,
    y: 0,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1510_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1510_21",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1510_21",
    x1: 46.5,
    y1: 35,
    x2: 46.5,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DC7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465FAF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepImage3);
export default __webpack_public_path__ + "static/media/StepImage3.3fd05207ff9371d68c1148c8955b3e27.svg";
export { ForwardRef as ReactComponent };